/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for CustomerProduct controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { UpdateCustomerProductRequest, RequestOptions, GetCustomerProductsByCustomerIdResponse, CreateCustomerProductRequest, CreateCustomerProductResponse, GetCustomerProductHistoryTimelineResponse, GetCustomerProductHistoryByCustomerIdResponse, GetCustomerProductBillingsByCustomerIdResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CustomerProductService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    updateCustomerProduct(id: number, updateCustomerProductRequest: UpdateCustomerProductRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateCustomerProduct(id: number, updateCustomerProductRequest: UpdateCustomerProductRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateCustomerProduct(id: number, updateCustomerProductRequest: UpdateCustomerProductRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateCustomerProduct(id: number, updateCustomerProductRequest: UpdateCustomerProductRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CustomerProduct/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateCustomerProductRequest, requestOptions);
    }

    deleteCustomerProduct(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteCustomerProduct(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteCustomerProduct(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteCustomerProduct(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CustomerProduct/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getCustomerProductsByCustomerId(customerId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCustomerProductsByCustomerIdResponse>;
    getCustomerProductsByCustomerId(customerId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCustomerProductsByCustomerIdResponse>>;
    getCustomerProductsByCustomerId(customerId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCustomerProductsByCustomerIdResponse>>;
    getCustomerProductsByCustomerId(customerId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CustomerProduct`;

        let params = new HttpParams();
        if (customerId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, customerId, 'customerId');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createCustomerProduct(createCustomerProductRequest: CreateCustomerProductRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateCustomerProductResponse>;
    createCustomerProduct(createCustomerProductRequest: CreateCustomerProductRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateCustomerProductResponse>>;
    createCustomerProduct(createCustomerProductRequest: CreateCustomerProductRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateCustomerProductResponse>>;
    createCustomerProduct(createCustomerProductRequest: CreateCustomerProductRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CustomerProduct`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createCustomerProductRequest, requestOptions);
    }

    getCustomerProductHistoryTimeline(startDate: Date, endDate: Date, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCustomerProductHistoryTimelineResponse>;
    getCustomerProductHistoryTimeline(startDate: Date, endDate: Date, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCustomerProductHistoryTimelineResponse>>;
    getCustomerProductHistoryTimeline(startDate: Date, endDate: Date, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCustomerProductHistoryTimelineResponse>>;
    getCustomerProductHistoryTimeline(startDate: Date, endDate: Date, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CustomerProduct/history/timeline`;

        let params = new HttpParams();
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getCustomerProductHistoryByCustomerId(customerId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCustomerProductHistoryByCustomerIdResponse>;
    getCustomerProductHistoryByCustomerId(customerId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCustomerProductHistoryByCustomerIdResponse>>;
    getCustomerProductHistoryByCustomerId(customerId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCustomerProductHistoryByCustomerIdResponse>>;
    getCustomerProductHistoryByCustomerId(customerId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CustomerProduct/history`;

        let params = new HttpParams();
        if (customerId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, customerId, 'customerId');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getCustomerProductBillingsByCustomerId(customerId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCustomerProductBillingsByCustomerIdResponse>;
    getCustomerProductBillingsByCustomerId(customerId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCustomerProductBillingsByCustomerIdResponse>>;
    getCustomerProductBillingsByCustomerId(customerId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCustomerProductBillingsByCustomerIdResponse>>;
    getCustomerProductBillingsByCustomerId(customerId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CustomerProduct/billings`;

        let params = new HttpParams();
        if (customerId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, customerId, 'customerId');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
